import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/core/models/api-response';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { environment } from 'src/environments/environment';
import { IAccountRequest, IAccountResponse } from '../models/account.model';

const headers = { 'content-type': 'application/json' };

@Injectable({
  providedIn: 'root',
})
export class AccountApiService {
  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/accounts`;
  }

  constructor(private http: HttpClient) {}

  loadAccounts(currentFilter?: MainTableFilterModel): Observable<ApiResponse<IAccountResponse[]>> {
    const params = createFilterParams(currentFilter);

    return this.http.get<ApiResponse<IAccountResponse[]>>(this.url, { params });
  }

  loadAllAccounts(): Observable<IAccountResponse[]> {
    const url = `${this.url}/List`;
    return this.http.get<IAccountResponse[]>(url);
  }

  loadAccountById(id: string): Observable<IAccountResponse> {
    const url = `${this.url}/${id}`;
    return this.http.get<IAccountResponse>(url);
  }

  createAccount(account: IAccountRequest): Observable<IAccountResponse> {
    return this.http.post<IAccountResponse>(this.url, account, { headers });
  }

  updateAccount(account: IAccountRequest): Observable<IAccountResponse> {
    const url = `${this.url}/${account.id}`;
    return this.http.put<IAccountResponse>(url, account, { headers });
  }

  deleteAccount(id: string): Observable<void> {
    const url = `${this.url}/${id}`;
    return this.http.delete<void>(url);
  }
}
